// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.ui.dimmer[data-v-1ee276ef] {\n    background-color: rgba(0,0,0,.25) !important;\n}\n.attestation-modal[data-v-1ee276ef] {\n    margin-top: 2em !important;\n}\n.attestation-modal-header[data-v-1ee276ef] {\n    text-align: center !important;\n    font-size: small !important;\n}\n", ""]);
// Exports
module.exports = exports;
